import React, { useState, useContext, useRef,useEffect } from 'react'
import { motion, AnimatePresence } from 'framer-motion'
import UserContext from '../../contexts/UserContext.js'
import toast from 'react-hot-toast';
import PlaneText_wb from './Elements/toast/planeText_wb.js'

export default function Upload() {
    const [star, setStar] = useState(false)
    const [uploading, setUploading] = useState(false)
    const [link, setLink] = useState("")
    const [title, setTitle] = useState("")
    const bookRef = useRef()



    const { bookModal, setBookModal, setSelectedBook, selectedBook } = useContext(UserContext);
    const validate__link = (link) => {
        return link != "";

    }
    useEffect(() => {
        setSelectedBook("")
    }, [])


    bookRef.current = selectedBook
    console.log("rendered")
    const addLink = () => {
        //uploading logic
        document.getElementById("add__link__btn").disabled = true;
        document.getElementById("add__fav__btn").disabled = true;
        document.getElementById("add__book__btn").disabled = true;

        setUploading(true);
        setTimeout(() => {
            setUploading(false);
            setLink("")
            setTitle("")
            setStar(false)
            setSelectedBook("")
            document.getElementById("add__link__btn").disabled = false;
            document.getElementById("add__fav__btn").disabled = false;
            document.getElementById("add__book__btn").disabled = false;
            toast.success(<PlaneText_wb msg="Link Added successfully" />, {
                duration: 1600,
                position: 'bottom-right',
                style: {
                    borderRadius: '10px',
                    background: '#333',
                    color: '#fff',
                },
            })
        }, 2000);
    }
    return (
        <div style={{ display: "flex", flexDirection: "row", flexWrap: "wrap", justifyContent: "space-around", alignItems: "center" }}>
            <div style={{ marginTop: 20, position: "relative", color: "rgb(43 83 218)", fontWeight: 500, padding: "10px 24px", borderRadius: 16, backgroundImage: "linear-gradient(91deg, rgba(255, 255, 255, 0.38), rgba(225, 225, 225, 0.78))", width: 270, display: "flex", alignItems: "center", fontSize: "170%" }}            >
                <img src="https://cdn.iconscout.com/icon/free/png-128/bookmark-1754138-1493251.png" alt="" style={{ width: 30 }} />
                <p>Link Manager</p>
                <h3 style={{ position: "absolute", bottom: "-43px", color: "#797373", fontSize: "70%" }}>Magage your Links Globaly</h3>
            </div>

            <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }} className="flex align-center justify-center  my-16 ">
                <div className="w-screen" style={{ padding: "27px 10px", borderRadius: 5, maxWidth: 650, backgroundColor: "#0093E9", backgroundImage: "linear-gradient(337deg, #0093E9 0%, #80D0C7 100%)", position: "relative" }}            >
                    <div style={{ position: "relative" }}>
                        <div style={{ position: "absolute", width: 30, top: 0, left: 0 }}                    >
                            {star && <img src="https://cdn.iconscout.com/icon/free/png-128/star-2456525-2036055.png" />}
                        </div>
                        <input value={link} onChange={(e) => setLink(e.target.value)} type="text" className="deletable" name="" id=""
                            style={{ margin: "auto", display: "block", height: 35, borderRadius: 3, border: "none" /* fontSize: '75%', */, fontSize: "81%", width: "83%", paddingLeft: 20 }}
                            placeholder="Add link . . ." />
                        <input value={title} onChange={(e) => setTitle(e.target.value)} type="text" className="deletable" name="" id=""
                            style={{ margin: "10px auto", display: "block", height: 35, borderRadius: 3, border: "none" /* fontSize: '75%', */, fontSize: "81%", width: "83%", paddingLeft: 20 }}
                            placeholder="Add title . . . (optional)" />
                        <div style={{ marginTop: 15, display: "flex", flexWrap: "wrap", flexDirection: "row", padding: "0px 75px", alignItems: "center", justifyContent: "flex-start" }} >
                            <div style={{ position: "relative", right: 35 }}>
                                <button id="add__fav__btn" className="bg-slate-300 hover:bg-slate-200" onClick={() => setStar(!star)} style={{ cursor: uploading ? "not-allowed" : "pointer", padding: 3, fontSize: "83%", color: "wheat", fontWeight: 600, borderRadius: 5, padding: 1, marginLeft: 9 }}>
                                    <img style={{ padding: 3 }} src="https://cdn.iconscout.com/icon/free/png-128/star-2456525-2036055.png" width="25" height="25" />

                                </button>
                                <button id="add__book__btn" className="bg-slate-300 hover:bg-slate-200" onClick={() => setBookModal(true)}
                                    style={{ cursor: uploading ? "not-allowed" : "pointer", fontSize: "83%", color: "wheat", fontWeight: 600, borderRadius: 5, padding: 1, marginLeft: 7 }}                           >
                                    <img
                                        src="https://cdn.iconscout.com/icon/free/png-256/add-1468-475004.png"
                                        width={25}
                                        height={25}
                                    />
                                </button>
                            </div>
                            <AnimatePresence>
                                {validate__link(link) &&
                                    < motion.button id="add__link__btn"
                                        onClick={addLink}
                                        initial={{ opacity: 0, x: -20 }}
                                        animate={{ opacity: 1, x: 0 }}
                                        exit={{ opacity: 0, x: -20 }}

                                        style={{ cursor: uploading ? "not-allowed" : "pointer", background: uploading ? 'rgb(60 117 134)' : "#1b6a8e", padding: "4px 25px", borderRadius: 6, color: "antiquewhite" }} >{" "}
                                        Add
                                    </motion.button>
                                }
                                {uploading && <div className="mx-10" role="status"> <svg aria-hidden="true" className="font-bold inline w-8 h-8 mr-2 text-gray-200 animate-spin dark:text-gray-600 fill-rose-600" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg" > <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor" /> <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill" /> </svg> <span className="sr-only">Loading...</span> </div>}
                            </AnimatePresence>
                            {bookRef.current != "" && <p style={{ position: "absolute", right: 6, bottom: 10, fontWeight: 500, color: "antiquewhite", background: "#4ab7d6", padding: "2px 10px", borderRadius: 3 }}>
                                {bookRef.current}
                            </p>}
                        </div>
                    </div>
                </div>
            </motion.div>
        </div>
    )
}
